export enum EFieldType {
	TEXT = 'Text',
	NUMBER = 'Number',
	BOOLEAN = 'Yes/No',
	SELECT = 'Pick From List',
	DATE = 'Date',
	MULTISELECT = 'Multiple Items',
}

export enum EFilterOperator {
	EQUALS = 'equals',
	NOT_EQUALS = 'not_equals',
	CONTAINS = 'contains',
	NOT_CONTAINS = 'not_contains',
	STARTS_WITH = 'starts_with',
	ENDS_WITH = 'ends_with',
	GREATER_THAN = 'greater_than',
	LESS_THAN = 'less_than',
	GREATER_EQUAL = 'greater_equal',
	LESS_EQUAL = 'less_equal',
	IS_EMPTY = 'is_empty',
	IS_NOT_EMPTY = 'is_not_empty',
	IN = 'in',
	NOT_IN = 'not_in',
}

export enum EViewType {
	TABLE = 'table',
	BOARD = 'board',
}

export enum ETabs {
	CUSTOMERS = 'customers',
	FIELDS = 'fields',
	OUTBOUND_TASK = 'Outbound Tasks',
}

export enum EActionType {
	CALL = 'call',
	EDIT = 'edit',
	DELETE = 'delete',
	VIEW = 'view',
}

export enum ECustomerStatus {
	ACTIVE = 'active',
	INACTIVE = 'inactive',
	VIP = 'vip',
	PROSPECT = 'prospect',
}

export enum EFieldMode {
	DISPLAY = 'display',
	EDIT = 'edit',
	FILTER = 'filter',
}

export enum EFilterLogic {
	AND = 'AND',
	OR = 'OR',
}

export enum ESortOrder {
	ASC = 'asc',
	DESC = 'desc',
}

export enum EComponentSize {
	SMALL = 'small',
	MIDDLE = 'middle',
	LARGE = 'large',
}

export enum ECustomerModalType {
	MANUAL = 'MANUAL',
	CSV_UPLOAD = 'CSV_UPLOAD',
}
